import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useIntl } from 'react-intl'
import Radio from 'components/shared/Radio/index'
import { useResolutions } from 'store/resolutions'
import { VOUCHER_DELIVERY_PRICE } from 'constants/prices'
import { formatPrice } from 'helpers/helpers'
import { handleError } from 'helpers/errors'
import { useAppSelector } from 'store/hooks'
import { useDispatch } from 'react-redux'
import { setErrors, setDeliveryType } from 'store/order-slice'
import {
    useCreateSelfcareCartItemMutation,
    useDeleteSelfcareCartItemByIdMutation,
    useGetProductQuery,
} from 'store/api-slice/hooks'
import { useApp } from 'store/steps'
import { v4 as uuidv4 } from 'uuid'
import Loader from 'components/shared/Loader'
import { useSelfcareCart } from 'store/selfcare-cart-slice/hooks'

const DeliveryOptions = () => {
    const { formatMessage } = useIntl()
    const { isTablet } = useResolutions()
    const { deliveryType } = useAppSelector((state) => state.order.shipping)
    const dispatch = useDispatch()
    const [postCartItem, postStatus] = useCreateSelfcareCartItemMutation()
    const [deleteCartItem, deleteStatus] =
        useDeleteSelfcareCartItemByIdMutation()
    const { language } = useApp()
    const { refetchSelfcareCart, isSelfcareCartFetching } = useSelfcareCart()
    const shippingOrderId = useAppSelector(
        (state) => state.selfcareCart.items.shipping?.cartItemId
    )

    const { data } = useGetProductQuery({
        _locale: language,
        productType: 'shipping',
    })

    const shippingId = data?.productId
    const isProcessing =
        postStatus.isLoading || deleteStatus.isLoading || isSelfcareCartFetching

    const setDeliveryOption = async (value: string) => {
        if (value !== 'email' && value !== 'shipping') return

        dispatch(setDeliveryType(value))
        dispatch(setErrors([]))

        if (!shippingOrderId && value === 'shipping') {
            try {
                await postCartItem({
                    _locale: language,
                    createCartItemSelfcareCommand: {
                        cartItemId: uuidv4(),
                        productId: shippingId,
                        productType: 'shipping',
                        quantity: 1,
                    },
                })

                refetchSelfcareCart()
            } catch (error) {
                handleError(error)
            }
        } else if (shippingOrderId && value === 'email') {
            try {
                await deleteCartItem({
                    cartItemId: shippingOrderId,
                    _locale: language,
                })

                refetchSelfcareCart()
            } catch (error) {
                handleError(error)
            }
        }
    }

    return (
        <Box mb={40}>
            <Box justify="center" gap={16} direction="row">
                <Text variant="heading4" mb={18}>
                    {formatMessage({
                        id: 'selfcare.payment.voucher_delivery_header',
                        defaultMessage: 'Sposób dostawy',
                    })}
                </Text>

                {isProcessing && <Loader />}
            </Box>

            <Box gap={[16, 40]} direction={['column', 'row']}>
                <Radio
                    options={[
                        {
                            option: formatMessage({
                                id: 'selfcare.payment.voucher_email_delivery_option',
                                defaultMessage: 'E-mail – za darmo!',
                            }),
                            id: 'email',
                        },
                        {
                            option: `${formatMessage(
                                {
                                    id: 'selfcare.payment.voucher_post_delivery_option',
                                    defaultMessage:
                                        'Wysyłka kurierem +{price} PLN',
                                },
                                {
                                    price: formatPrice(VOUCHER_DELIVERY_PRICE),
                                }
                            )}`,
                            id: 'shipping',
                        },
                    ]}
                    direction={isTablet ? 'column' : 'row'}
                    value={deliveryType}
                    setValue={setDeliveryOption}
                    isDisabled={isProcessing}
                    testIdPrefix="payment-delivery"
                />
            </Box>
        </Box>
    )
}

export default DeliveryOptions
